import { createSelector } from 'reselect';

export const onboardingSelector = (state) => state.talentNetworkOnboarding;

export const isTalentOnboardingComplete = createSelector(onboardingSelector, (state) =>
  Boolean(state.talentOnboarding),
);

export const isTalentOnboardingError = createSelector(onboardingSelector, (state) => state.error);
